import { useState } from "react";
import { ArrowRight, CalendarDays, Flame } from "lucide-react";
import { HeartPulse, Sparkles, Plane, Utensils, ShoppingBag, GraduationCap, Building, Scissors, Home, Car, Banknote, Briefcase, Lightbulb, Laptop, Calendar } from "lucide-react";
import { Link } from "react-router-dom";


const blogData = {
  searchBy: ["Travel", "Beauty", "Food", "Health", "Marketing"],
  posts: [
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Automotive_Business/Automotive_1.png",
      date: "April 2025",
      comments: "23",
      title: "Supercharge Your Automotive Business with WhatsApp Solutions",
      content:
        "Promote your vehicles, services, and deals through powerful WhatsApp broadcasts. Offer round-the-clock customer support to handle inquiries at any time. Showcase your products, including cars and accessories, on a WhatsApp storefront.",
      link: "/whatsapp-business-for-automotive-industry"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Banking_Finance/Banking_Finance_1.png",
      date: "April 2025",
      comments: "15",
      title: "Transform Banking & Finance with WhatsApp",
      content: "Simplify KYC with secure ID and document checks. Answer customer questions anytime, day or night. Show off your financial services with a WhatsApp storefront.",
      link: "/whatsapp-business-for-banking-and-finance"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Beauty_Cosmetics/Beauty_and_Cosmetics_1.png",
      date: "April 2025",
      comments: "38",
      title: "Elevate Your Beauty & Cosmetics Brand with WhatsApp",
      content: "Show off your products with a stunning WhatsApp storefront. Send exclusive offers to thousands of customers in a snap. Keep in touch 24/7 with smart WhatsApp automation.",
      link: "/whatsapp-business-for-beauty-cosmetics-brands"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/edutech/EdTech_1.png",
      date: "April 2025",
      comments: "7",
      title: "Grow Your EdTech with WhatsApp",
      content: "Send friendly reminders for tests, fees, and results. Make learning easier, affordable, and flexible for students. Chat one-on-one with students for a personal touch.",
      link: "/whatsapp-business-for-edutech"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/event_and_webinar/event_and_webinar_1.png",
      date: "April 2025",
      comments: "42",
      title: "Skyrocket Your Events with WhatsApp | ChatMitra",
      content: "Fill seats fast with instant WhatsApp invites. Keep attendees in the loop with smart reminders. Make every event a hit with real-time updates.",
      link: "/whatsapp-business-for-event-and-webinar"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Freelancer/Freelancer_1.png",
      date: "April 2025",
      comments: "19",
      title: "Skyrocket Your Freelancer and Consultant Sales Using WhatsApp",
      content:
        "Automate FAQs to answer client questions swiftly and efficiently. Send secure, encrypted e-invoices directly for ongoing projects. Keep clients connected with personalized updates and notifications.",
      link: "/whatsapp-business-for-freelancer-and-consultant-sales"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/health_wellness/health_wellness_1.png",
      date: "April 2025",
      comments: "31",
      title: "Grow Your Health & Wellness Business with WhatsApp",
      content:
        "Recover lost sales with automated abandoned cart reminders. Share exciting deals and discounts through WhatsApp broadcasts. Display your wellness products beautifully in a WhatsApp catalog.",
      link: "/whatsapp-business-for-health-wellness-brands"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/home_decor_furnishings/home_decor_furnishings_1.png",
      date: "April 2025",
      comments: "9",
      title: "Grow Your Home Decor & Furnishings Business with WhatsApp",
      content: "Answer questions fast with automated FAQs to speed up sales. Share your stunning product catalog right on WhatsApp. Stay connected with customers 24/7 for better engagement.",
      link: "/whatsapp-business-for-home-decor-and-furnishings"
    },
    // {
    //   imageUrl: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/lhsre1dbw7z4yuoz.webp?w=1024&dpr=2",
    //   date: "April 2025",
    //   comments: "27",
    //   title: "Power Up Your Tech Company with WhatsApp",
    //   content: "Reach more leads and turn them into customers with ease. Offer round-the-clock support to keep users happy. Perfect for startups, IT providers, and SaaS companies.",
    //   link: "/whatsapp-business-for-IT-services-and-internet"
    // },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_1.png",
      date: "April 2025",
      comments: "14",
      title: "Skyrocket Client Conversions with WhatsApp",
      content: "Bring in more leads and sales for your clients effortlessly. Offer 24/7 support to keep customers happy and engaged. Send personal nudges to spark buying interest.",
      link: "/whatsapp-business-for-marketing-agency"
    },
    // {
    //   imageUrl: "https://umsousercontent.com/lib_EyxlwrMuBuWXHRhZ/lhsre1dbw7z4yuoz.webp?w=1024&dpr=2",
    //   date: "April 2025",
    //   comments: "46",
    //   title: "Expand Your Retail Business with WhatsApp | ChatMitra",
    //   content:
    //     "Showcase your retail products on WhatsApp with ChatMitra’s easy catalog feature. Answer customer questions in seconds using WhatsApp chatbots or live support. Boost sales with 95% open rates, leaving email’s 20% in the dust.",
    //   link: "/whatsapp-business-for-offline-and-retail"
    // },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/education/education_1.png",
      date: "April 2025",
      comments: "33",
      title: "Boost Your Education Goals with WhatsApp | ChatMitra",
      content: "Speed up admissions with instant WhatsApp messaging. Engage students with automated, personal chats. Simplify communication with powerful analytics.",
      link: "/whatsapp-business-for-education"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/real_estate/real_estate_1.png",
      date: "April 2025",
      comments: "12",
      title: "Grow Your Real Estate Business with WhatsApp | ChatMitra",
      content: "Sell properties faster with instant messaging. Generate leads without breaking the bank. Keep buyers hooked with smart automation.",
      link: "/whatsapp-business-for-real-estate"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/Restaurant/restaurant_and_food_1.png",
      date: "April 2025",
      comments: "28",
      title: "Grow Your Restaurant & Food Business with WhatsApp Magic",
      content:
        "Showcase your delicious menu using WhatsApp Catalogs. Let customers order and pay directly through WhatsApp for convenience. Provide 24/7 support to ensure every customer feels valued.",
      link: "/whatsapp-business-for-restaurants-food-businesses"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/spa_salon/spa_salon_1.png",
      date: "April 2025",
      comments: "17",
      title: "Boost Spa & Salon Bookings with WhatsApp Solutions",
      content:
        "Send irresistible offers and discounts to thousands of customers instantly. Stay connected 24/7 with smart WhatsApp automation. Highlight your services beautifully with a WhatsApp storefront.",
      link: "/whatsapp-business-for-spas-and-salons"
    },
    {
      imageUrl: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/travel_agency/travel_agency_post_1.png",
      date: "April 2025",
      comments: "41",
      title: "Grow Your Travel Agency Leads Using WhatsApp Effectively",
      content:
        "Launch click-to-WhatsApp ads featuring special travel offers to attract attention. Share WhatsApp links on social media and other platforms to boost visibility. Embed a WhatsApp widget on your website to start conversations instantly. Send automated welcome messages to engage customers and gather more details.",
      link: "/whatsapp-business-for-travel-and-tourism"
    }
  ]
};

const allCategoriesData = [
  {
    name: "Health",
    icon: HeartPulse,
    link: "/whatsapp-business-for-health-wellness-brands"
  },
  {
    name: "Beauty",
    icon: Sparkles,
    link: "/whatsapp-business-for-beauty-cosmetics-brands"
  },
  {
    name: "Travel",
    icon: Plane,
    link: "/whatsapp-business-for-travel-and-tourism"
  },
  {
    name: "Food",
    icon: Utensils,
    link: "/whatsapp-business-for-restaurants-food-businesses"
  },
  // {
  //   name: "offline & Retail",
  //   icon: ShoppingBag,
  //   link: "/whatsapp-business-for-offline-and-retail"
  // },
  {
    name: "Education",
    icon: GraduationCap,
    link: "/whatsapp-business-for-education"
  },
  {
    name: "Real Estate",
    icon: Building,
    link: "/whatsapp-business-for-real-estate"
  },
  {
    name: "spa & salons",
    icon: Scissors,
    link: "/whatsapp-business-for-spas-and-salons"
  },
  {
    name: "Home Decor",
    icon: Home,
    link: "/whatsapp-business-for-home-decor-and-furnishings"
  },
  {
    name: "Automative",
    icon: Car,
    link: "/whatsapp-business-for-automotive-industry"
  },
  {
    name: "Banking & Finance",
    icon: Banknote,
    link: "/whatsapp-business-for-banking-and-finance"
  },
  {
    name: "Freelancer & Consultant",
    icon: Briefcase,
    link: "/whatsapp-business-for-freelancer-and-consultant-sales"
  },
  {
    name: "Marketing Business",
    icon: Lightbulb,
    link: "/whatsapp-business-for-marketing-agency"
  },
  {
    name: "Edutech",
    icon: GraduationCap,
    link: "/whatsapp-business-for-edutech"
  },
  // {
  //   name: "IT Services & Internet",
  //   icon: Laptop,
  //   link: "/whatsapp-business-for-IT-services-and-internet"
  // },
  {
    name: "Event & Webinar",
    icon: Calendar,
    link: "/whatsapp-business-for-event-and-webinar"
  }
];

const Categories = () => {
  const [showAll, setShowAll] = useState(false);

  const displayedCategories = showAll ? allCategoriesData : allCategoriesData.slice(0, 4);

  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-xl font-bold mb-4 text-[#075E54]">Categories</h3>
      <ul className="space-y-2">
        {displayedCategories.map((category, index) => {
          const IconComponent = category.icon;
          return (
            <li key={index}>
              <Link to={category.link} className="block">
                <div className="flex items-center p-3 text-gray-700 hover:bg-[#075E54] hover:text-white rounded-lg transition-all duration-200">
                  <IconComponent className="w-5 h-5 mr-4 transition-colors duration-200 group-hover:text-white" />
                  <span className="transition-colors duration-200 group-hover:text-white">{category.name}</span>
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
      <button onClick={toggleShowAll} className="mt-4 w-full text-center text-[#075E54] hover:text-white bg-[#075E54]/10 hover:bg-[#075E54] px-4 py-2 rounded-lg transition-all duration-200">
        {showAll ? "Show Less" : "Show All"}
      </button>
    </div>
  );
};

const App = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Sidebar */}
          <div className="md:col-span-1 order-first md:order-last">
            <div className="sticky top-4 space-y-6">
              <Categories />
            </div>
          </div>

          {/* Main Content */}
          <div className="md:col-span-3 order-last md:order-first">
            {/* Search Input and Title */}
            <div className="flex flex-col sm:flex-row justify-between items-center mb-8 gap-4">
              <h2 className="text-3xl font-bold text-[#075E54]">Trending Blogs</h2>
              <div className="w-full sm:w-64">
                <div className="relative">
                  <input type="text" className="w-full px-4 py-2 border border-gray-300 focus:border-[#075E54] focus:outline-none rounded-lg shadow-sm transition-colors" placeholder="Search..." />
                  <svg className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#075E54]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 21l-6-6m2-6a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
              </div>
            </div>
            {/* Two Blog Posts Row */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {blogData.posts.map((post, index) => (
                <div
                  key={index}
                  className="bg-white shadow-md rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-[#075E54] border-transparent"
                >
                  <div className="relative overflow-hidden">
                    <img
                      src={post.imageUrl}
                      alt="Blog Post"
                      className="w-full h-64 object-cover bg-[#075E54] transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#075E54]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute bottom-0 left-0 bg-[#075E54] text-white px-4 py-2 text-sm">
                      {post.comments} comments
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="text-[#075E54] text-sm mb-2">{post.date}</p>
                    <h2 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-[#075E54] transition-colors">
                      {post.title}
                    </h2>
                    <p className="text-gray-600 mb-4 group-hover:text-gray-900 transition-colors">
                      {post.content}
                    </p>
                    <Link to={post.link} className="inline-flex items-center text-[#075E54] font-semibold hover:text-[#075E54]/80 transition-all duration-200">
                      Read More
                      <ArrowRight className="w-4 h-4 ml-2 transform transition-transform duration-200 group-hover:translate-x-1" />
                    </Link>
                  </div>
                </div>
              ))}
            </div> */}
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              {blogData.posts.map((post, index) => (
                <Link
                  to={post.link}
                  key={index}
                  className="group block bg-white shadow-md rounded-lg overflow-hidden transition-all duration-300 hover:shadow-lg hover:-translate-y-1 hover:border-[#075E54] border border-transparent"
                >
                  <div className="relative overflow-hidden">
                    <img src={post.imageUrl} alt="Blog Post" className="w-full  object-cover transition-transform duration-300 group-hover:scale-105" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#075E54]/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <div className="absolute bottom-0 left-0 bg-[#075E54] text-white px-4 py-2 text-sm">{post.comments} comments</div>
                  </div>
                  <div className="p-6">
                    <p className="text-[#075E54] text-sm mb-2">{post.date}</p>
                    <h2 className="text-xl font-bold mb-3 text-gray-900 group-hover:text-[#075E54] transition-colors">{post.title}</h2>
                    <p className="text-gray-600 mb-4 group-hover:text-gray-900 transition-colors">{post.content}</p>
                    <span className="inline-flex items-center text-[#075E54] font-semibold hover:text-[#075E54]/80 transition-all duration-200">
                      Read More
                      <ArrowRight className="w-4 h-4 ml-2 transform transition-transform duration-200 group-hover:translate-x-1" />
                    </span>
                  </div>
                </Link>
              ))}
            </div>
            {/* Search By */}
            <div className="bg-white p-6 rounded-lg shadow-md mt-8">
              <h3 className="text-xl font-bold mb-4 text-[#075E54]">Search By</h3>
              <div className="flex flex-wrap gap-2">
                {blogData.searchBy.map((search, index) => (
                  <Link key={index} to={getSearchLink(search)}>
                    <div className="bg-gray-200 text-[#075E54] px-4 py-2 text-sm rounded-lg hover:bg-[#075E54] hover:text-white transition-all duration-200 cursor-pointer">{search}</div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const getSearchLink = (category) => {
  switch (category.toLowerCase()) {
    case "travel":
      return "/whatsapp-business-for-travel-and-tourism";
    case "beauty":
      return "/whatsapp-business-for-beauty-cosmetics-brands";
    case "food":
      return "/whatsapp-business-for-restaurants-food-businesses";
    case "health":
      return "/whatsapp-business-for-health-wellness-brands";
    case "marketing":
      return "/whatsapp-business-for-marketing-agency";
    default:
      return "#";
  }
};

export default App;
